import { memo, useState } from "react"
import { makeStyles } from "tss-react/mui"
import { Typography, IconButton } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleInfo } from "@fortawesome/pro-regular-svg-icons"
import { ProductsTableItem } from "../../../../../../modules/merchant/admin/products/productsTypes"
import { SearchableText } from "../../../../search/Searchable"
import { ProductDetailsDialog } from "./ProductDetailsDialog"

const MAX_CHARS = 54

const useStyles = makeStyles()((theme) => ({
    productTitle: {
        display: "-webkit-box",
        WebkitBoxOrient: "vertical",
        WebkitLineClamp: 3,
        overflow: "hidden",
        minHeight: "4.5rem",
        lineHeight: "1.5rem",
        overflowWrap: "anywhere",
        wordBreak: "normal",
    },
    iconWrap: {
        display: "inline-flex",
        whiteSpace: "nowrap",
        position: "relative",
        top: ".25rem",
    },
    iconButton: {
        padding: "0",
        color: theme.palette.tailwind.slate[400],
        transition: "all 0.3s ease-out",
        marginLeft: ".25rem",
        fontSize: "1rem",
        lineHeight: "1.5rem",
        "&:hover": {
            color: theme.palette.tailwind.slate[500],
        },
    },
}))

type ProductDetailsContentProps = {
    product: ProductsTableItem
    searchRegex: RegExp | undefined
}

export const ProductDetailsContent = memo(({ product, searchRegex }: ProductDetailsContentProps) => {
    const { classes } = useStyles()
    const [productId, setProductId] = useState<number | null>(null)

    const handleDetailsClick = () => {
        setProductId(product.id)
    }

    const productTitleLength = product.name.length
    const isOverLimit = productTitleLength > MAX_CHARS

    const title = isOverLimit ? product.name.slice(0, MAX_CHARS) : product.name

    return (
        <>
            <SearchableText search={searchRegex}>
                <Typography variant="subtitle1" className={classes.productTitle}>
                    {title}
                    {isOverLimit && "..."}
                    {"\u00A0"}
                    <Typography className={classes.iconWrap}>
                        <IconButton onClick={handleDetailsClick} className={classes.iconButton} size="small">
                            <FontAwesomeIcon icon={faCircleInfo} />
                        </IconButton>
                    </Typography>
                </Typography>
            </SearchableText>

            {productId && <ProductDetailsDialog productId={productId} handleClose={() => setProductId(null)} />}
        </>
    )
})
